import { NgModule } from '@angular/core';
import { FooterComponent } from './footer/footer.component';


@NgModule({
  imports: [],
  declarations: [
    FooterComponent
  ],
  exports:[
    FooterComponent
  ]
})
export class FooterModule { }
